var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","open-delay":"700"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"mx-2",attrs:{"label":"","small":"","color":_vm.amount > 0 ? 'error' : 'grey darken-4',"dark":""}},on),[_vm._v(" "+_vm._s(_vm.name)+": "+_vm._s(_vm.amount)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }